<template>
  <v-app-bar
    app
    :elevate-on-scroll="true"
    color="white"
    clipped-right
  >
    <v-app-bar-nav-icon
      v-if="showButton"
      color="primary"
      class="hidden-sm-and-up"
      @click.stop="toggleDrawer"
    />

    <v-btn
      v-if="showButton"
      small
      color="primary"
      class="mr-2 px-xs-only-0 hidden-xs-only"
      text
      @click.stop="toggleDrawer"
    >
      Menu
    </v-btn>

    <v-toolbar-title
      v-resize="toggleShowButton"
      class="width-100"
    >
      <portal-target name="titlebarContents">
        <h1 class="title-text">
          {{ titleContent }}
        </h1>
      </portal-target>
    </v-toolbar-title>
    <v-spacer />
    <help-button
      v-if="helpUrl"
      :small="isMobile"
      :help-url="helpUrl"
    />
  </v-app-bar>
</template>

<script>
import HelpButton from '@/components/HelpButton'

export default {
  name: 'TitleBar',
  components: { HelpButton },
  data: () => ({
    showButton: false
  }),
  computed: {
    titleContent() {
      return (
        (this.titleBarContents &&
          this.$route.name &&
          this.$gnp(this.titleBarContents, this.$route.name)) ||
        this.$route.meta.title
      )
    },
    helpUrl() {
      return this.$route.meta.helpUrl
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < this.$navMobileBreakpoint
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_account'])
    this.mapGetters(['isIndividual'])
    this.mapStates(['drawer', 'account', 'titleBarContents'])
  },
  methods: {
    toggleDrawer() {
      this.$store.commit('set_drawer', !this.drawer)
    },
    toggleShowButton() {
      this.showButton = this.isMobile
    }
  }
}
</script>

<style lang="scss" scoped>
.title-text {
  padding: 0 12px;
  color: var(--v-darkslategray-base);
  font-family: $heading-font-family;
}
</style>
